import type { ComponentTheme } from '../types/component-theme';

export default {
    slots: {
        root: 'flex flex-col items-center justify-center font-(family-name:--secondary-font)',
        hiddenTitle: 'visually-hidden',
        logoWrap:
            'relative mb-10 inline-block transition-transform duration-500 ease-[cubic-bezier(0.25,1,0.5,1)] ' +
            'hover:scale-105',
        logo: 'mx-auto h-40 drop-shadow-[0_25px_25px_rgba(0,0,0,0.15)]',
        card:
            'relative w-full max-w-lg overflow-hidden rounded-[1.875rem] bg-(--input-frozen-bg) ' +
            'shadow-[0_0.5rem_2rem_rgba(0,0,0,0.15),0_0.125rem_0.5rem_rgba(0,0,0,0.05),inset_0_0.063rem_0_rgba(255,255,255,0.04),inset_0_-0.063rem_0_rgba(255,255,255,0.02)] ' +
            'backdrop-blur-[0.625rem] backdrop-saturate-[1.2] before:pointer-events-none before:absolute ' +
            'before:inset-0 before:rounded-[1.875rem] before:p-[0.063rem] ' +
            'before:bg-[linear-gradient(180deg,rgba(57,57,57,0.21)_1%,rgba(151,151,151,0.35)_100%)] ' +
            'before:mask-[var(--mask-white-fill-bg)_content-box,var(--mask-white-fill-bg)] before:mask-exclude ' +
            'after:pointer-events-none after:absolute after:top-0 after:left-[10%] after:right-[10%] ' +
            'after:h-[0.063rem] after:bg-[linear-gradient(90deg,transparent,var(--white-alpha-06),transparent)]',
        sideGlow:
            'pointer-events-none absolute top-[10%] left-0 h-[80%] w-px ' +
            'bg-[linear-gradient(180deg,var(--input-frozen-border),var(--input-frozen-focus-bg),transparent)]',
        innerHighlight:
            'pointer-events-none absolute inset-[0.063rem] rounded-[1.813rem] ' +
            'shadow-[inset_0_0_0.125rem_0_rgba(255,255,255,0.15),inset_0_0.125rem_0.25rem_0_rgba(255,255,255,0.08),inset_0_-0.125rem_0.125rem_0_rgba(255,255,255,0.12)]',
        radialGlow:
            'pointer-events-none absolute inset-0.5 rounded-[1.75rem] ' +
            'bg-[radial-gradient(circle_at_30%_20%,var(--white-alpha-03)_0%,transparent_70%)] mix-blend-overlay',
        content: 'relative z-10 p-8 md:p-12',
        headerWrap: 'mb-10 text-center',
        header: 'mb-2 text-3xl font-bold uppercase tracking-[-0.047rem] text-white',
        subheader: 'text-xs font-bold uppercase tracking-[0.075rem] text-[#999]',
        footer: 'mt-6 border-t border-white/15 pt-5',
        footerContent: 'flex items-center justify-between gap-3',
        footerPrompt: 'text-sm text-white/60'
    }
} satisfies ComponentTheme;
